import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-stages',
  storeModule.createStoreModule('real-estate-developments-stages')
)
